import React from 'react';
import ReviewForm from './ReviewForm';
import ReviewDisplay from './ReviewDisplay';

const ReviewModal = ({ 
  isOpen, 
  onClose, 
  mode, // 'create' or 'view'
  booking,
  currentUserId,
  reviewId, // for viewing existing review
  onReviewSubmitted // optional callback(reviewId) invoked after successful submit
}) => {
  if (!isOpen) return null;

  const getReviewType = () => {
    if (!booking || !currentUserId) return null;
    
    if (parseInt(booking.host_id) === parseInt(currentUserId)) {
      return 'host_review';
    } else if (parseInt(booking.wwoofer_id) === parseInt(currentUserId)) {
      return 'wwoofer_review';
    }
    return null;
  };

  const getMemberId = () => {
    if (!booking || !currentUserId) return null;
    
    if (parseInt(booking.host_id) === parseInt(currentUserId)) {
      return parseInt(booking.wwoofer_id);
    } else if (parseInt(booking.wwoofer_id) === parseInt(currentUserId)) {
      return parseInt(booking.host_id);
    }
    return null;
  };

  const handleSubmitSuccess = (newReviewId = null) => {
    // Notify parent that a review was created/updated so it can update its UI
    if (typeof onReviewSubmitted === 'function') {
      try {
        onReviewSubmitted(newReviewId);
      } catch (e) {
        // swallow - callback should not break modal flow
        // eslint-disable-next-line no-console
        console.error('onReviewSubmitted callback error', e);
      }
    }

    // Close modal after a short delay to allow any animations or toast messages
    setTimeout(() => {
      onClose();
      // Could trigger a refresh of booking data here if desired
    }, 450);
  };

  const reviewType = getReviewType();
  const memberId = getMemberId();

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>
            {mode === 'create' ? 'Leave a Review' : 'View Review'}
          </h2>
          <button 
            className="modal-close" 
            onClick={onClose}
            aria-label="Close modal"
          >
            ×
          </button>
        </div>
        
        <div className="modal-body">
          {mode === 'create' ? (
            <ReviewForm 
              bookingId={booking?.id}
              memberId={memberId}
              reviewType={reviewType}
              onSubmitSuccess={handleSubmitSuccess}
              onCancel={onClose}
            />
          ) : (
            <ReviewDisplay 
              reviewId={reviewId}
              onClose={onClose}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ReviewModal;
